// extracted by mini-css-extract-plugin
export default {"modal":"y_-z","modalContent":"z_-z","footer":"A_-z","cancelBtn":"B_-z","disabled":"C_-z","formWrapper":"D_-z","fade":"E_-z","fade-in":"F_-z","iframe":"G_-z"};